import { Game } from './engine/Game.js';

/**
 * Main entry point for Cat Simulator: Revenge of the Feline
 */

// Initialize and start the game
const game = new Game();
game.start();

// Make game available globally for debugging
// @ts-ignore - Adding game to window for debugging
window.game = game;
